import React from "react";
import ReactDOM from "react-dom";
//Redux
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import reducers from "./reducers";

// Service worker
import * as serviceWorker from "./common/serviceWorker";

// App
import App from "./App";
import AppEmbbedded from "./AppEmbedded";

//Globalization
import {
  I18nProvider,
  loadTranslationMessages,
} from "./providers/I18nProvider";

import { load } from "@progress/kendo-react-intl";
import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import currencyData from "cldr-core/supplemental/currencyData.json";
import weekData from "cldr-core/supplemental/weekData.json";

import usNumbers from "cldr-numbers-full/main/en/numbers.json";
import usLocalCurrency from "cldr-numbers-full/main/en/currencies.json";
import usCaGregorian from "cldr-dates-full/main/en/ca-gregorian.json";
import usDateFields from "cldr-dates-full/main/en/dateFields.json";

import esNumbers from "cldr-numbers-full/main/es/numbers.json";
import esLocalCurrency from "cldr-numbers-full/main/es/currencies.json";
import esCaGregorian from "cldr-dates-full/main/es/ca-gregorian.json";
import esDateFields from "cldr-dates-full/main/es/dateFields.json";

import ptNumbers from "cldr-numbers-full/main/pt/numbers.json";
import ptLocalCurrency from "cldr-numbers-full/main/pt/currencies.json";
import ptCaGregorian from "cldr-dates-full/main/pt/ca-gregorian.json";
import ptDateFields from "cldr-dates-full/main/pt/dateFields.json";

load(
  likelySubtags,
  currencyData,
  weekData,
  usNumbers,
  usLocalCurrency,
  usCaGregorian,
  usDateFields,
  esNumbers,
  esLocalCurrency,
  esCaGregorian,
  esDateFields,
  ptNumbers,
  ptLocalCurrency,
  ptCaGregorian,
  ptDateFields,
);

//Redux
const store = createStore(reducers, applyMiddleware(thunk));
loadTranslationMessages();

const AppRender =
  process.env.REACT_APP_ENTRY === "embedded" ? (
    <AppEmbbedded />
  ) : (
    <I18nProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </I18nProvider>
  );

ReactDOM.render(AppRender, document.getElementById("root"));

serviceWorker.unregister();
